// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsContent_content__RlOzT","title":"TermsContent_title__Gzcoy","text":"TermsContent_text__YgPFX"};